import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
// import { useTheme } from '@emotion/react';

export const McdInvStatusDefinitionsDialog = () => {
  const rsrc = useRsrc();
  const [open, setOpen] = useState(true);

  const [invStatuses, setInvStatuses] = useState([]);

  // const theme = useTheme();

  useEffect(() => {
    rsrc.data('sc', 'MCD_INV_STATUS_DEFINITIONS_DATA_PLUGIN', {}).then((invStatuses) => {
      setInvStatuses(invStatuses);
    });
  }, []);

  if (invStatuses.length === 0) return null;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxHeight="50%">
      <DialogTitle>Invoice State Transition Diagram</DialogTitle>
      <DialogContent dividers>
        <img
          src="/assets/images/InvStatusStateTransitionDiagram.png"
          alt="Invoice Status State Transition Diagram"
          style={{ width: '100%', height: 'auto' }}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
